import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import app from 'pageApp';
import Radio from 'backbone.radio';
import tagManager from '@component/common/src/util/TagManagerUtil';
import Storage from '@component/common/src/util/ClientSideStorage';
import Cookie from '@component/common/src/util/Cookie';
import UserStatus from '@component/common/src/util/UserStatus';
import CacheManager from '@component/common/src/util/CacheManager';
import StringUtil from '@component/common/src/util/StringUtil';
import ModalOverlay from '@component/modal-overlay';
import ObjectUtil from '@core/util/object';
import LazyLoad from '@core/util/lazyload';
import IntersectionObserver from '@core/util/intersection-observer';
import ProductThumbnail from '../ProductThumbnail';
import template from '../../templates/partials/component-product-thumbnail/mcom/product-thumbnail.hbs';
import ProductImage from '../../components/mcom/ProductImage';
import ListHeartHandler from './ListHeartHandler';
import PromoBadgeTpl from '../../templates/partials/component-product-thumbnail/mcom/promo-badge.hbs';

const BagChannel = Radio.channel('bag');

export default ProductThumbnail.extend({
  LARGE_BREAKPOINT: 1483,
  MEDIUM_BREAKPOINT: 1195,
  LARGE_IMAGE_WIDTH: 376,
  MEDIUM_IMAGE_WIDTH: 319,
  SMALL_IMAGE_WIDTH: 224,

  template,
  bootstrap(data = {}) {
    if (data.product) {
      const { pageProperties } = data;
      const { traits, detail, pricing } = data.product; /* eslint-disable-line no-unused-vars */
      const { properties } = data.product.meta ? data.product.meta : '';
      const { dbedThumbnailRedesignEnabled } = data;
      const snbTemplateUrlRemovalattrs = {
        snbTemplateUrlRemovalEnabled: data.snbTemplateUrlRemovalEnabled,
        productUrlTemplate: data.productUrlTemplate || (properties && properties.productUrlTemplate ? properties.productUrlTemplate : ''),
        swatchUrlTemplate: data.swatchUrlTemplate || (properties && properties.swatchUrlTemplate ? properties.swatchUrlTemplate : ''),
      };
      if (data.swatchImageOptimizationEnabled) {
        traits.swatchImageOptimizationEnabled = data.swatchImageOptimizationEnabled;
        this.swatchImageOptimizationEnabled = data.swatchImageOptimizationEnabled;
      }
      if (traits) {
        this.buildProductColorSwatch(traits, detail, snbTemplateUrlRemovalattrs);
      }

      if (data.isSwatchOptExpEnabled) {
        traits.showSwatchOptExpEnabled = true;
      }

      if (dbedThumbnailRedesignEnabled) {
        detail.flags.isdbedThumbnailRedesignEnabled = dbedThumbnailRedesignEnabled;
      }
      // swatches are not required for GWP type products
      if (!(pageProperties && pageProperties.isGWPEnabled) && traits) {
        this.carouselSwatchImage(traits);
      }
      this.pricing = pricing;
    }
    /* handle SR text badges */
    this.setUserTier();
    this.removeIneligibleLoyaltyBadges();
    this.showLoyaltyBadgeText();
    /* */
    if (data.tierName && (data.tierName === 'GOLD' || data.tierName === 'PLATINUM')) {
      this.hideFreeShipPromotionBadge();
    }
    this.slotId = data.slotId;
    this.pageType = data.pageType;
    this.makeResponsive();
    this.updateProductThumbnailUrl(data.cmParams, data.slotId, data.sizeFacetParam, data.isMLT, data.cId);
    if (data.isMLT) {
      if (app.getMeta('properties.callToActionLink')) {
        this.extractFacetsFromUrl();
      } else {
        this.updateMLTUrl();
      }
    }
  },
  ui: {
    thumbnailImage: '.thumbnailImage',
    colorSwatch: '.colorSwatch',
    badgeHeader: '.badgeHeader',
    badgeRebate: '.badgeRebate',
    productLink: '.productDescLink',
    moreSwatchLink: '.moreSwatchesLink',
    listHearts: '.listHearts',
    buyAgainButton: '.buyagain-btn',
    carouselBtnNext: 'button.m-carousel-button.next',
    callToAction: '.call-to-action',
    addToBag: '.addToBag',
  },
  events: {
    'mouseover @ui.colorSwatch': 'swatchSelection',
    'mouseout @ui.colorSwatch': 'swatchSelection',
    'click @ui.colorSwatch': 'swatchSelection',
    'mouseover @ui.badgeHeader': 'badgeToolTip',
    'mouseout @ui.badgeHeader': 'badgeToolTip',
    'click @ui.badgeRebate': 'badgeRebate',
    'click @ui.productLink': 'updateParams',
    'click @ui.moreSwatchLink': 'fireTagOnMoreSwatchLink',
    'click @ui.listHearts': 'listHeartsEvents',
    'click @ui.carouselBtnNext': 'OnClickRightChevron',
    'click @ui.addToBag': 'addToBagClick',
  },
  initialize() {
    if (this.model) {
      this.model = new Backbone.Model(this.model.get('product'));
      this.buildProductColorSwatch(this.model.get('traits'), this.model.get('detail'));
      this.model.set({ meta: Object.assign({}, this.model.get('meta'), this.options.pageMeta || {}) });
      /* handle SR text badges */
      this.setUserTier();
      if (this.model.get('pricing')) {
        this.model.set('pricing', this.determineSREligibility(this.model.get('pricing')));
      }
      if (this.model.get('meta') && this.model.get('meta').properties && this.model.get('meta').properties.listHeartsEnabled) {
        this.$el.on('component::productThumbnail::heartClicked', (event, trackingName, productId) => {
          this.heartClickTracking(trackingName, productId);
        });
      }
      this.homepageRecentlyViewedEnabled = ObjectUtil.getChildProperty(this.model.get('meta'), 'properties.homepageRecentlyViewedEnabled');
    }
    this.facetPersistenceEnabled = app.getMeta('properties.facetPersistenceEnabled');
    this.sizeFacetPersistenceEnabled = app.getMeta('properties.sizeFacetPersistenceEnabled');
  },
  makeResponsive() {
    ProductImage.attachAdditionalImagesByCollection(this.$el.find('img.thumbnailImage'));
  },
  setUserTier() {
    const signedIn = UserStatus.isSignedIn() || UserStatus.isSoftSignedIn();
    if (signedIn) {
      if (!this.userTier) {
        const userID = Cookie.get('macys_online_uid');
        const tierInfoCache = CacheManager.getPersistent(`hnfsr_${userID}`);
        const userTier = tierInfoCache && tierInfoCache.tierInfo && tierInfoCache.tierInfo.tierName ? tierInfoCache.tierInfo.tierName : null;
        this.userTier = userTier;
      }
    }
  },
  // this is for Node server-side rendered browse/search products that are bootstrapped from canvas.js
  //   in which there is no XAPI response
  //   and the data is directly rendered Node server-side
  // the server-side rendered template will have a class called "loyalty-{{eligibleTier}}-badge-type"
  // which tells you which user tier the Loyalty badge is for
  // we remove all badges whose user tiers do not match the given account holder's user tier
  removeIneligibleLoyaltyBadges() {
    if (this.userTier) {
      this.$('.star-image-badge').not(`.loyalty-${this.userTier}-badge-type`).not('.loyalty-ALL-badge-type').remove();
    }
  },
  // this is for Node server-side rendered browse/search products that are bootstrapped from canvas.js
  //   in which there is no XAPI response
  //   and the data is directly rendered Node server-side
  // we have to manually show the badge and add a user tier class to the CSS
  // because the template doesn't reload to update the model
  showLoyaltyBadgeText() {
    if (this.userTier) {
      // this condition occurs when a loyalty badge is in product-thumbnail.hbs
      if (this.$('.star-image-badge') && this.$('#star-image-holder').attr('class')) {
        const starImageClasses = this.$('#star-image-holder').attr('class').replace(' -star', ` ${this.userTier}-star`);
        // this assumes that we only have one Star Rewards badge text offer (since Stella should only show the best offer)
        this.$('#star-image-holder').attr('class', starImageClasses);
        this.$('#star-image-holder').removeClass('hideHeader');
        this.$('#star-image-holder').siblings('#starHeader').removeClass('hide');
      }
    }
  },
  // if we are given a badge with eligible/loyaltyEligible tiers, we determine
  // the user is logged in and the user's Star Rewards tier matches the eligible/loyaltyEligible tiers
  // (or eligible/loyaltyEligible tiers are set to all Star Rewards users)
  // if yes, we add their Star Rewards tier ("userTier") to the badge data in the model
  // if no, we remove the badge from the response
  // NOTE that this does not work for browse/search sortable-grid badges
  //   in which there is no XAPI response
  //   and the data is directly rendered Node server-side
  //   in that case, we instead use "removeIneligibleLoyaltyBadges" and "showLoyaltyBadgeText"
  determineSREligibility(pricing) {
    // if the response has badges
    pricing.badges = pricing.badges ?
      pricing.badges.reduce((result, currentBadge) => {
        // if the current badge is a Star Rewards badge
        if (currentBadge.eligibleTier || currentBadge.loyaltyEligibleTier) {
          // if the user is logged in
          const userTier = this.userTier;
          if (userTier) {
            if (currentBadge.eligibleTier === userTier || currentBadge.loyaltyEligibleTier === userTier) {
              // if we are given a badge with an eligible/loyaltyEligible tier
              // and if the user's Star Rewards tier matches the eligible/loyaltyEligible tier
              // we keep the badge
              result.push(currentBadge);
            } else if ((currentBadge.eligibleTier && currentBadge.eligibleTier.match(/all/i)) || (currentBadge.loyaltyEligibleTier && currentBadge.loyaltyEligibleTier.match(/all/i))) {
              // or if we are given a badge with an eligible/loyaltyEligible tier
              // and if the eligible/loyaltyEligible tier is set to all Star Rewards users
              // we keep the badge
              result.push(currentBadge);
            }
          }
          // if the user is not logged in
          // or if the user's Star Rewards tier doesn't match the eligible/loyaltyEligible tier
          // (and the eligible/loyaltyEligible tier is not set to all Star Rewards users)
          // we don't keep the badge (we don't push the currentBadge to the result)
          return result;
        }
        // if the badge doesn't contain an eligible/loyaltyEligible Tier, we keep the badge in the response and make no changes
        result.push(currentBadge);
        return result;
      }, []) : [];
    return pricing;
  },
  updateProductThumbnailUrl(cmParams, slotId, sizeFacetParam, isMLT, cId) {
    const productUrl = this.$el.find('.productDescLink');
    _.each(productUrl, (val, idx) => {
      if (this.sizeFacetPersistenceEnabled && sizeFacetParam) {
        productUrl[idx].href += `&sizes=${sizeFacetParam}`;
      }

      if (isMLT && cId && (slotId || slotId === 0)) {
        const catId = StringUtil.getURLParameter('CategoryID');
        productUrl[idx].href += `&tdp=cm_choiceId~z${encodeURIComponent(cId)}~xcm_pos~zPos${parseInt(slotId + 1, 10)}~xcm_srcCatID~z${catId}`;
      }
      if (cmParams) {
        productUrl[idx].href += cmParams;
      }
      if (slotId || slotId === 0) {
        productUrl[idx].href += encodeURIComponent(`&slotId=${parseInt(slotId + 1, 10)}`);
      }
    });
  },
  updateMLTUrl() {
    const similarProductContainer = this.$el.find('.similar-products-feature');
    similarProductContainer.removeClass('hidden').addClass('mltPros');
    $(similarProductContainer).find('a').attr('href', (i, a) => a.replace(/(image_[\w]*)/g, 'pros'));
    const mltURL = $(similarProductContainer).find('a').attr('href');
    const imageId = StringUtil.getURLParameter('imageId', mltURL);
    const lid = `&lid=more_like_this-pros-${imageId}-${this.$el.attr('id')}`;
    $(similarProductContainer).find('a').attr('href', `${mltURL}${lid}`);
    this.extractFacetsFromUrl();
  },
  extractFacetsFromUrl() {
    let facetParam = '';
    const mltLink = this.$el.find('.similar-products-feature').find('a');
    const mltUrlArray = mltLink.length > 0 ? mltLink.attr('href').split('?') : '';
    if (this.pageType && this.pageType.search) {
      facetParam = document.location.pathname.split('/').slice(3).join('/');
    } else {
      facetParam = document.location.pathname.split('/').slice(4).join('/');
    }

    if (mltUrlArray.length > 0) {
      mltLink.attr('href', `${mltUrlArray[0]}/${facetParam}?${mltUrlArray[1]}`);
    }
  },
  getColor(el) {
    if (!el) return undefined;
    let colorTitle;

    // Swatch structure is usually li > div > span
    switch (el.tagName) {
      case 'SPAN':
        colorTitle = $(el).parent('div').attr('title');
        break;
      case 'DIV':
        colorTitle = $(el).attr('title');
        break;
      case 'LI':
        colorTitle = $(el).find('div').attr('title');
        break;
      default:
        colorTitle = undefined;
    }

    return colorTitle;
  },
  getImageWidth() {
    if (window.innerWidth >= this.LARGE_BREAKPOINT) {
      return this.LARGE_IMAGE_WIDTH;
    } else if (window.innerWidth < this.LARGE_BREAKPOINT && window.innerWidth >= this.MEDIUM_BREAKPOINT) {
      return this.MEDIUM_IMAGE_WIDTH;
    }
    return this.SMALL_IMAGE_WIDTH;
  },
  swatchSelection(e) {
    ProductThumbnail.prototype.swatchSelection.call(this, e);
    let relatedColor;
    const swatchSelection = $(e.currentTarget).children('div');
    let swatchProductPreview = swatchSelection.data('preview');
    let swatchAdditionalImage = swatchSelection.data('colorswatchimg');
    let swatchMoreLikeThis = swatchSelection.data('value');
    const swatchProductId = swatchSelection.parents('.colorSwatchesContainer').data('colorswatchproduct');
    const thumbnailImage = swatchSelection.parents().find(`#img_${swatchProductId}`);
    let jumboSwatchUrl = swatchSelection.data('jumboswatchurl');
    const primaryImage = swatchSelection.data('img-id');
    const catId = swatchSelection.parents('.colorSwatchesContainer').data('catid');
    const similarProductContainer = this.$el.find('.similar-products-feature');
    const isProductGirdEnhancementEnabled = app.getMeta('properties.productGridEnhancementEnabled');

    if (isProductGirdEnhancementEnabled) {
      relatedColor = this.getColor(e.relatedTarget);
    }

    // For mouseout, relatedTarger's color tells us where it's hovering over
    if (!$(e.currentTarget).hasClass('swatchColorsMore') && e.type === 'mouseout' &&
        ((isProductGirdEnhancementEnabled && !relatedColor) || !isProductGirdEnhancementEnabled)) {
      swatchProductPreview = this.$el.find('.swatchSelected').data('preview');
      swatchAdditionalImage = this.$el.find('.swatchSelected').data('colorswatchimg');
      jumboSwatchUrl = this.$el.find('.swatchSelected').data('jumboswatchurl');
    }
    if (e.type === 'click') {
      const mltLink = this.$el.find('.similar-products-feature a');
      if (!similarProductContainer.hasClass('mltPros')) {
        swatchMoreLikeThis = this.$el.find('.swatchSelected').data('value');
        if (swatchMoreLikeThis && similarProductContainer.hasClass('mlt-hide')) {
          if (!similarProductContainer.hasClass('has-hide')) {
            similarProductContainer.addClass('has-mlt');
          }

          const mltLinkBtn = mltLink.find('button');
          const modelId = mltLinkBtn.data('model-id');
          const similarProductsURL = `/shop/similar-products?productId=${swatchProductId}&imageId=${primaryImage}&modelId=${modelId}&cm_sp=MLT_RESP-_-${modelId}-_-${primaryImage}_${swatchProductId}`;
          mltLink.attr('href', similarProductsURL);
        } else {
          similarProductContainer.removeClass('has-mlt');
        }
      } else {
        const lid = `&lid=more_like_this-pros-${primaryImage}-${swatchProductId}`;
        const similarProductsURL = `/shop/similar-products?productId=${swatchProductId}&imageId=${primaryImage}&CategoryID=${catId}&modelId=pros&cm_sp=MLT_RESP-_-pros-_-${primaryImage}_${swatchProductId}${lid}`;
        mltLink.attr('href', similarProductsURL);
      }
    }
    if (!jumboSwatchUrl) {
      thumbnailImage.attr('src', swatchProductPreview);
      thumbnailImage.attr('data-src', swatchAdditionalImage);
      if (isProductGirdEnhancementEnabled && swatchAdditionalImage) {
        this.imageWidth = this.getImageWidth();
        swatchProductPreview += `&wid=${this.imageWidth}`;
        thumbnailImage.prevAll().attr('srcset', swatchProductPreview);
      } else {
        thumbnailImage.prev().attr('srcset', swatchProductPreview);
      }
    }
  },
  updateParams(event) {
    event.stopImmediatePropagation();
    let selectedColor;
    const el = event.currentTarget;
    const locationAttrs = el.href.split('#');
    const $thumbnail = $(el).closest('.productThumbnail');
    const productId = $thumbnail.attr('id');

    const selectedSwatchDiv = $thumbnail.find('.colorSwatchesContainer .swatchSelected');
    if (selectedSwatchDiv.length > 0) {
      selectedColor = selectedSwatchDiv.attr('title');
    }
    if (this.facetPersistenceEnabled && selectedColor) {
      locationAttrs[0] = `${locationAttrs[0]}&swatchColor=${encodeURIComponent(selectedColor)}`;
      el.href = locationAttrs.join('#');
    }

    this.$el.trigger('component::productThumbnail::clicked', [productId]);
    let position;
    if (this.slotId && this.slotId >= 0) {
      position = this.slotId;
    } else {
      position = (this.model ? this.model.get('position') : '');
    }
    this.fireTagOnClick(position, productId, this.pageType);
    if (this.model && this.model.get('zone') && this.model.get('zone') === 'SB_ZONE_UNAVAILABLE') {
      const utagData = {
        site_action: 'more like this complete',
        action_location: 'shopping bag',
        action_misc: 'mlt complete - product click',
      };
      tagManager.fireTag('link', utagData);
    }
    return true;
  },
  hideFreeShipPromotionBadge() {
    const badges = this.$el.find(this.ui.badgeHeader);
    if (badges) {
      _.each(badges, (badge) => {
        if (badge.dataset.promotionType === 'Free Shipping') {
          $(badge).hide();
        }
      });
    }
  },
  heartClickTracking(eventName, productId) {
    console.log('heart click tracking being called');
    let productPrice = '';
    const tieredPrice = this.model.get('pricing').price.tieredPrice;
    if (tieredPrice[1]) {
      productPrice = [tieredPrice[1].values[0].value.toString()];
    }
    const utagData = {
      event_name: eventName,
      product_id: [productId],
      product_name: [this.model.get('detail').name],
      product_original_price: [tieredPrice[0].values[0].value.toString()],
      product_price: productPrice,
      reccomendation_model: '',
      position: this.model.get('position'),
      zone_title: 'recently viewed items',
      reccomendation_zone: '',
    };
    tagManager.fireTag('link', utagData);
  },

  listHeartsEvents(e) {
    console.log('list heart events kicking off');
    e.stopPropagation();
    e.preventDefault();
    // Add to list
    const $el = $(e.currentTarget);
    const productId = $el.closest('.productThumbnail').attr('id');

    if ($el.hasClass('icon-gen-heart-gr-large')) {
      ListHeartHandler.heartAddToList(productId, $el, this);
    } else {
      ListHeartHandler.heartRemoveFromList(productId, $el, this);
    }
  },
  renderBuyAgain() {
    this.$el.find('.productThumbnailImage')
      .append(`<button aria-haspopup="true" class="button primary small expand buyAgainButton hide-for-medium buyagain-btn">Buy again</button>
                <a href="/shop/product?ID=${this.el.id}&lid=buy_again" class="button primary small expand show-for-medium-down buyAgainButton buyagain-link">Buy again</a>`);
    this.$('.qvLauncherContainer').remove();
  },

  onRender() {
    this.showLoyaltyBadgeText();
    if (this.model && ObjectUtil.getChildProperty(this.model.get('meta'), 'properties.isElegantLoading')) {
      this.lazyLoadThumbnail();
    }
  },

  OnClickRightChevron() {
    if (!Storage.getSession('ifClickedOnRightChevron')) {
      const utagData = {
        link_name: 'swatches_arrows',
      };
      tagManager.fireTag('link', utagData);
      Storage.setSession('ifClickedOnRightChevron', true);
    }
  },

  fireTagOnMoreSwatchLink(e) {
    let selectedColor;
    const el = e.currentTarget;
    const $thumbnail = $(el).closest('.productThumbnail');
    let elHref = $thumbnail.find('.productThumbnailImage a').attr('href');
    const locationAttrs = elHref.split('#');

    const selectedSwatchDiv = $thumbnail.find('.colorSwatchesContainer .swatchSelected');
    if (selectedSwatchDiv.length > 0) {
      selectedColor = selectedSwatchDiv.attr('title');
    }
    if (this.facetPersistenceEnabled && selectedColor) {
      locationAttrs[0] = `${locationAttrs[0]}&swatchColor=${encodeURIComponent(selectedColor)}`;
      elHref = locationAttrs.join('#');
    }
    if (!Storage.getSession('isLIDAddedToURL')) {
      const utagData = {
        link_name: 'swatches_plus',
      };
      tagManager.fireTag('link', utagData);
      Storage.setSession('isLIDAddedToURL', true);
    }
    $(el).find('a').attr('href', elHref);
  },

  addToBagClick(e) {
    e.preventDefault();
    const upcNumber = this.getUpcNumber();

    const bagModel = BagChannel.request('get:model');
    const data = { item: { quantity: 1, upcId: upcNumber, mltAddToBag: true } };
    const utagData = {
      site_action: 'more like this complete',
      action_location: 'shopping bag',
      action_misc: 'mlt complete - atb',
    };
    if (bagModel.addToBag) {
      bagModel.addToBag(data);
    }
    tagManager.fireTag('link', utagData);
    BagChannel.trigger('on:load-unavailable-mlt-pros-panel');
  },
  getUpcNumber() {
    const product = this.model.attributes;
    const { traits } = product;
    const pColors = traits.colors;
    const pSizes = traits.sizes;
    const { upcs } = product.relationships;
    const upcArray = Object.values(upcs);
    let selectedSizeId;
    let selectedColorId;
    let upcNumber = '';

    if (pSizes && pSizes.selectedSize) {
      selectedSizeId = pSizes.selectedSize;
    }
    if (pColors && pColors.selectedColor) {
      selectedColorId = pColors.selectedColor;
    }

    if (upcArray.length > 0) {
      for (let i = 0; i < upcArray.length; i++) {
        if (selectedSizeId !== undefined && upcArray[i].traits.sizes && upcArray[i].traits.sizes.selectedSize) {
          if (parseInt(selectedSizeId, 10) === parseInt(upcArray[i].traits.sizes.selectedSize, 10)) {
            upcNumber = upcArray[i].id;
          }
        }
        if (selectedColorId !== undefined && upcArray[i].traits.colors && upcArray[i].traits.colors.selectedColor) {
          if (selectedColorId && parseInt(selectedColorId, 10) === parseInt(upcArray[i].traits.colors.selectedColor, 10)) {
            upcNumber = upcArray[i].id;
          }
        }
      }
    }
    return upcNumber;
  },
  badgeToolTip(e) {
    const badgeHeader = $(e.currentTarget);
    const badgeIndex = badgeHeader.data('badge-index');
    const pricing = this.pricing;
    if (e.type === 'mouseover') {
      if (ObjectUtil.getChildProperty(pricing, 'badges')) {
        const promoBadge = pricing.badges.find((val, idx) => val.description && badgeIndex === idx);
        if (promoBadge) {
          badgeHeader.before(PromoBadgeTpl(promoBadge));
        }
      }
    } else if (e.type === 'mouseout') {
      badgeHeader.prev('.badgeToolTip').remove();
    }
  },
  badgeRebate(e) {
    this.getRebateBadge($(e.currentTarget));
  },
  getRebateBadge(badgeRebate) {
    $.ajax({
      type: 'GET',
      url: badgeRebate.data('rebateurl'),
      dataType: 'html',
      timeout: 5000,
    }).done((rebateHtml) => {
      const overlay = new ModalOverlay({
        id: badgeRebate.data('rebateid'),
        width: badgeRebate.data('width'),
        height: badgeRebate.data('height'),
        content: rebateHtml,
        destroyOnClose: true,
      });
      overlay.open();
    });
  },
  lazyLoadThumbnail() {
    const lli = new LazyLoad(null, []);
    const io = new IntersectionObserver(target => lli.ready.then(() => lli.load(target, true)));
    io.ready.then(() => io.subscribe([...this.$el.context.querySelectorAll('img.lazy')]));
  },
});
